import { render, staticRenderFns } from "./newsEdit.vue?vue&type=template&id=75e95858&"
import script from "./newsEdit.vue?vue&type=script&lang=js&"
export * from "./newsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports